import * as R from 'ramda'
import P from 'helpers/predicates'
import { buffers } from 'redux-saga'

import {
  MODULE_NAME,
  NOTIFICATION,
  NOTIFICATION_END
} from './constants'

import ERROR_WHITE_LIST from './errors'

/*
const isError = (action) => R.test(/ERROR/g, action.type)
const isSuccess = (action) => R.any(R.flip(R.equals(action.type)))([])
const isFinished = (action) => action.type === NOTIFICATION_END
*/
const invalidErrors = R.compose(
  R.not,
  R.flip(R.contains)(ERROR_WHITE_LIST),
  R.prop('type')
)
const validErrors = R.anyPass([
  R.compose(
    R.equals(NOTIFICATION.ERROR),
    R.prop(MODULE_NAME)
  ),
  R.compose(
    R.test(/ERROR/g),
    R.prop('type')
  )
])
const isError = R.both(invalidErrors, validErrors)

const isSuccess = (action) => R.equals(NOTIFICATION.SUCCESS, action[MODULE_NAME])
const isInfo = (action) => R.equals(NOTIFICATION.INFO, action[MODULE_NAME])
const isFinished = (action) => R.equals(NOTIFICATION_END, action.type)

const isNotificationType = R.anyPass([
  isInfo,
  isFinished,
  isError,
  isSuccess,
])

/*
 * Drops all messages not of current priority,
 * therefore once it hits finished than it will reset priority
 *
 * Details:
 * Check if buffer has higher priority
 * if buffer has higher priority than drop
 * else cancel and start new notification
 * therefore buffer should always only have 1 notification
 * also listen for finished if finished than reset
 */
const getPriority = R.cond([
  [isFinished, R.always(NOTIFICATION.FINISHED)],
  [isError, R.always(NOTIFICATION.ERROR)],
  [isInfo, R.always(NOTIFICATION.INFO)],
  [isSuccess, R.always(NOTIFICATION.SUCCESS)],
])

const priorityBuffer = (limit = 1) =>  {
  const buffer = buffers.sliding(limit)
  let priority = 0

  const push = (action, notification) => {
    if (notification.priority > priority) {
      priority = notification.priority
      buffer.put(action)
    }
  }

  const put = (action) => {
    const notification = getPriority(action)
    switch (notification) {
      case NOTIFICATION.INFO:
        if (notification.priority >= priority)
          buffer.put(action)
        break
      case NOTIFICATION.FINISHED:
      case NOTIFICATION.ERROR:
      case NOTIFICATION.SUCCESS:
        push(action, notification)
        break
      default:
        // Not a valid type of action
    }
  }
  const take = () => {
    const item = buffer.take()
    if (buffer.isEmpty())
      priority = 0
    return item
  }

  return {
    isEmpty: buffer.isEmpty,
    take,
    put,
  }
}

export {
  isError,
  isSuccess,
  isFinished,
  isNotificationType,
  getPriority,
  priorityBuffer as buffer,
}

export default priorityBuffer
